import React, { useState } from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import FormButton from "../../components/form-components/FormButton.js";
import Input from "../../components/form-components/Input.js";
import TextArea from "../../components/form-components/TextArea.js";

const AddComponent = ({ show, close, saveComponent, parentComponent }) => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	
	const handleNameChange = (event) => {
		setName(event.target.value);
	};

	const handleDescriptionChange = (event) => {
		setDescription(event.target.value);
	};

	return ReactDOM.createPortal(
		<>
			{show ? (
				<div
					className="bg-black bg-opacity-50 z-10 fixed grid content-center place-content-center items-center top-0 left-0 right-0 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
					onClick={() => close()}
				>
					<div
						className="w-128 bg-card relative border border-card-bd rounded-card p-4"
						onClick={(e) => e.stopPropagation()}
					>
						<div className="modal_header">
							<div className="modal_header-title font-semibold text-lg">
								Add component
								<button
									className="close absolute right-5"
									onClick={() => close()}
								>
									<FontAwesomeIcon icon={regular("xmark")} className="" />
								</button>
							</div>
						</div>

						<div className="border-y border-border my-4 py-4">

							<div className="text-text-2 mb-5">
								Add an component under the <span className="font-bold">{parentComponent.name}</span> component.
							</div>

							<Input
								name={"name"}
								isLoaded={true}
								title="Name"
								onChange={handleNameChange}
								autoFocus={true}
							/>
							<TextArea
								type="text"
								name={"description"}
								id="description"
								isLoaded={true}
								className=""
								title="Description"
								placeholder=""
								onChange={handleDescriptionChange}
								required
							/>
						</div>
						<div className="text-right pt-3 pb-3">
							<FormButton title="Cancel" onClick={() => close()} />
							<FormButton
								title="Add component"
								style="primary"
								onClick={() => saveComponent(name, description, parentComponent.id)}
							/>
						</div>
					</div>
				</div>
			) : null}
		</>,
		document.body
	);
};

export default AddComponent;
